import React from "react";
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
} from "@material-ui/core";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const RESETPASSWORD = gql`
  mutation resetPassword($password: String!) {
    resetPassword(password: $password)
  }
`;

export default function ResetPassword() {
  const Alert = useAlert();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      password: "",
      checkPassword: "",
    },
  });

  const password = useWatch({ name: "password", control });

  const [resetPassword, { loading }] = useMutation(RESETPASSWORD, {
    onCompleted({ resetPassword }) {
      if (resetPassword) {
        Alert.alert("", "儲存成功", [
          {
            text: "確定",
            onPress: reset(),
            type: "ok",
          },
        ]);
      } else {
        Alert.alert("", "儲存失敗，請再次嘗試。", [
          { text: "確定", type: "ok" },
        ]);
      }
    },
  });

  function _save(data) {
    resetPassword({ variables: { password: data.password } });
  }

  return (
    <Card>
      <LoadingModal loading={loading} />
      <CardContent>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card>
              <CardHeader title={"修改密碼"} style={{ textAlign: "center" }} />
              <CardContent>
                <Grid container spacing={3} justifyContent="center">
                  <Grid item container>
                    <Controller
                      name="password"
                      control={control}
                      rules={{
                        required: "密碼為必填",
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          type={"password"}
                          label="新密碼"
                          fullWidth
                          error={error}
                          helperText={error && error.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item container>
                    <Controller
                      name="checkPassword"
                      control={control}
                      rules={{
                        validate: (v) => {
                          if (v !== password) return "確認密碼錯誤，請重新填寫";
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          {...field}
                          type={"password"}
                          label="確認新密碼"
                          fullWidth
                          error={error}
                          helperText={error && error.message}
                        />
                      )}
                    />
                  </Grid>
                  <Grid container item justify={"center"}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit(_save)}
                    >
                      修改
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
